import React, { useEffect, useState } from "react";
import { Modal, Select, Typography } from "antd";
import { request, showNotification } from "@thewebops/admin-panel";
import actions from "../actions";

const coachName = (coach) => coach.name || coach.email;

// Deactivating keeps the coach's conversations and members (nutivate-api#98),
// so the admin is told that before confirming.
export const confirmDeactivate = (dispatch, item) => {
  Modal.confirm({
    title: `Deactivate ${coachName(item)}?`,
    content:
      "They won't be able to sign in. Their conversations and messages are kept, and you can activate them " +
      "again later. Their members stay assigned to them until you move them.",
    okText: "Deactivate",
    okButtonProps: { danger: true },
    cancelText: "Cancel",
    // No return value: antd keeps the modal open when onOk returns something other than a promise.
    onOk: () => {
      dispatch(actions.lockCoach.request({ item }));
    },
  });
};

// Active coaches, other than the one the members are moving from.
const CoachPicker = ({ sourceId, onSelect }) => {
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    request({ url: "admin/coaches", method: "get", authenticated: true, params: { show_all: true } })
      .then(({ data }) => {
        if (mounted) setCoaches(data.coaches.filter((coach) => !coach.locked && coach.id !== sourceId));
      })
      .catch(() => showNotification("Coach", "error", "The coaches couldn't be loaded. Please try again."))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, [sourceId]);

  return (
    <Select
      showSearch
      loading={loading}
      placeholder="Choose the new coach"
      optionFilterProp="label"
      style={{ width: "100%" }}
      options={coaches.map((coach) => ({ label: coachName(coach), value: coach.id, coach }))}
      onChange={(_value, option) => onSelect(option.coach)}
    />
  );
};

// Moves every member of a deactivated coach to the chosen coach. Their conversations follow them.
export const openMoveMembers = (dispatch, item) => {
  let target = null;
  const count = (item.coach_users || []).length;
  const modal = Modal.confirm({
    title: `Move ${coachName(item)}'s members`,
    icon: null,
    content: (
      <>
        <Typography.Paragraph>
          {count} {count === 1 ? "member moves" : "members move"} to the coach you choose, with their conversations and
          messages.
        </Typography.Paragraph>
        <CoachPicker
          sourceId={item.id}
          onSelect={(coach) => {
            target = coach;
            modal.update({ okButtonProps: { disabled: false } });
          }}
        />
      </>
    ),
    okText: "Move members",
    okButtonProps: { disabled: true },
    cancelText: "Cancel",
    onOk: () => {
      dispatch(actions.moveCoachMembers.request({ item, target }));
    },
  });
};
